import EditProjectDetailsForm from "Forms/EditProjectDetailsForm";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";

class DescriptionFormModal extends Component {
  state = {
    success: false,
    error: null,
    fetching: false
  };

  handleSubmit = values => {
    const { updateProjectDetails, projectDetails } = this.props;

    this.setState({ fetching: true });

    const resolve = {
      onSuccess: () => {
        this.setState({
          error: null,
          success: true,
          fetching: false
        });
      },
      onFailure: e => {
        this.setState({
          error: e.message,
          success: false,
          fetching: false
        });
      }
    };

    const data = {
      id: projectDetails.id,
      ...values
    };

    updateProjectDetails(data, resolve);
  };

  render() {
    const { show, onHide, projectDetails } = this.props;
    const { fetching, success, error } = this.state;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>This is the header</Modal.Header>
        <Modal.Body>
          <EditProjectDetailsForm
            handleSubmit={this.handleSubmit}
            projectName={projectDetails.projectName}
            projectDescription={projectDetails.projectDescription}
            fetching={fetching}
            error={error}
            success={success}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectDetails: ProjectSelectors.getProjectDetails(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateProjectDetails: (data, resolve) =>
      dispatch(ProjectActions.updateProjectDetailsRequest(data, resolve))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DescriptionFormModal);
